import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from '../../../api/queryKeys';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { useRouteParams } from '../../../hooks/useRouteParams';

export const WHAT_IFS_MK = 'whatIfs';

interface SetWhatIfsMutationParams {
  howMuchSaved: number;
  totalInvestableAssets: number;
  yearsBeforeWithdrawal: number;
}

const setWhatIfsMutation = ({ clientId }) => ({
  howMuchSaved,
  totalInvestableAssets,
  yearsBeforeWithdrawal,
}: SetWhatIfsMutationParams) => {
  return authFetch(
    urlWithParams('/Consumer/AutomatedAccountsUpdate/WhatIf', {
      clientId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions({ howMuchSaved, totalInvestableAssets, yearsBeforeWithdrawal }, true),
    },
  );
};

export const useWhatIfsMutation = () => {
  const { clientId } = useRouteParams();

  const queryClient = useQueryClient();

  const queryKey = queryKeys.automatedAccountsResults(clientId);

  return useMutation(setWhatIfsMutation({ clientId }), {
    onSuccess(data) {
      queryClient.setQueryData(queryKey, data);
    },

    mutationKey: WHAT_IFS_MK,
  });
};
